/**
 * upgradeAddonModalButtons.tsx
 */
import Container from '../../atoms/container/modalButtons';
import Focus from '@shared/types/enums/focus';
import List from '../../sections/list/list';
import ModalButton from '../buttons/ui/modalButton';
import TranslationManager from '@shared/assets/locale/translationsManager';
import { popFocus, pushFocus } from '@shared/store/slices/focus.slice';
import { popRoute } from '@shared/store/thunks/route.thunk';
import { useAppDispatch } from '@shared/store/hooks';
import { useEffect } from 'react';

/**
 * Displays the upgrade addon modal buttons.
 */
export default function UpgradeAddonModalButtons() {
  const dispatch = useAppDispatch();

  const buttons = [
    {
      title: TranslationManager.get('MODAL.UPGRADE_ADDON.BUTTONS.CLOSE'),
      releaseAction: () => {
        dispatch(popRoute());
      },
    },
  ];

  useEffect(() => {
    dispatch(pushFocus(Focus.MODAL_BUTTONS));
    return () => {
      dispatch(popFocus());
    };
  }, []);

  return (
    <Container>
      <List focus={Focus.MODAL_BUTTONS}>
        {buttons.map((item, index) => {
          return (
            <ModalButton
              index={index}
              key={index}
              releaseAction={item.releaseAction}
              text={item.title}
            />
          );
        })}
      </List>
    </Container>
  );
}
